import { UseGetProductResponse } from "types/queries";

import { trackPdcEvent } from "./track-pdc-event";

export const trackValidationFailureEvent = (
  product: UseGetProductResponse,
  formTrackingId: string,
  fieldName: string,
  validationKey: string,
  step: string | number,
  subStep: string | number
) => {
  trackPdcEvent(
    product,
    `${formTrackingId}:${fieldName}:${validationKey}`,
    "validation_failure",
    step,
    subStep
  );
};
